import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'zzz', 'IconZzz', [["path",{"d":"M4 12h6l-6 8h6","key":"svg-0"}],["path",{"d":"M14 4h6l-6 8h6","key":"svg-1"}]]);